import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { useAtomValue } from "jotai";

import { FieldDrawerHeader } from "components/fieldBuilder/fieldDrawerHeader";

import { ControlField, getFieldTypeInfo } from "./fieldBuilderUtils";

interface ControlFieldDrawerHeaderProps {
    fieldAtom: FormAtom<ControlField>;
}
export function ControlFieldDrawerHeader({
    fieldAtom,
}: ControlFieldDrawerHeaderProps) {
    const field = useAtomValue(fieldAtom);
    const info = getFieldTypeInfo()(field.fieldType.type);
    return <FieldDrawerHeader fieldTypeInfo={info} />;
}
